import React, { useState } from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { AddSucursalIcon } from '../../../../assets/svg/iconos';

import { HorarioExtraItem } from './HorarioExtraItem';

const timezone = process.env.REACT_APP_TIMEZONE;

export const getDefaultProfessionalHours = (objProfesional, fechaBase = null) => {
    const fecha = fechaBase || moment().tz(timezone);
    
    let horaInicioDefault = fecha.clone().hours(8).minutes(0).seconds(0).milliseconds(0);
    let horaFinDefault = fecha.clone().hours(20).minutes(0).seconds(0).milliseconds(0);
    
    if (objProfesional?.horarioSucursales && objProfesional.horarioSucursales.length > 0) {
        for (const sucursal of objProfesional.horarioSucursales) {
            if (sucursal.horarios && sucursal.horarios.length > 0) {
                for (const horario of sucursal.horarios) {
                    if (horario.horas && horario.horas.length > 0) {
                        let minInicio = null;
                        let maxFin = null;
                        
                        for (const hora of horario.horas) {
                            if (hora.horaInicio && hora.horaFin) {
                                const inicio = moment.tz(hora.horaInicio, timezone);
                                const fin = moment.tz(hora.horaFin, timezone);
                                
                                if (!minInicio || inicio.isBefore(minInicio)) {
                                    minInicio = inicio;
                                }
                                if (!maxFin || fin.isAfter(maxFin)) {
                                    maxFin = fin;
                                }
                            }
                        }
                        
                        if (minInicio && maxFin) {
                            horaInicioDefault = fecha.clone()
                                .hours(minInicio.hours()).minutes(minInicio.minutes()).seconds(0).milliseconds(0);
                            horaFinDefault = fecha.clone()
                                .hours(maxFin.hours()).minutes(maxFin.minutes()).seconds(0).milliseconds(0);
                            return { horaInicioDefault, horaFinDefault };
                        }
                    }
                }
            }
        }
    }
    
    return { horaInicioDefault, horaFinDefault };
};

export const HorarioExtra = ({ editMode, objProfesional, horariosExtraTemp, setHorariosExtraTemp, deleteHorarioExtra, descansosTemp = [] }) => {
    const { colores } = useSelector( state => state.ui );

    const [contadorNewItems, setContadorNewItems] = useState(0);

    const addHorarioExtra = () => {
        const fechaActual = moment().tz(timezone);
        const { horaInicioDefault, horaFinDefault } = getDefaultProfessionalHours(objProfesional, fechaActual);
        
        const fechaBase = fechaActual.clone().startOf('day');
        const initialFechaInicio = fechaBase.clone().hours(horaInicioDefault.hours()).minutes(horaInicioDefault.minutes()).toDate();
        const initialFechaFin = fechaBase.clone().hours(horaFinDefault.hours()).minutes(horaFinDefault.minutes()).toDate();

        const newHorarioExtra = {
            empresa: objProfesional.empresa,
            profesional: objProfesional.usuario || objProfesional._id,
            fechaFin: moment.tz(initialFechaFin, timezone).toISOString(),
            fechaInicio: moment.tz(initialFechaInicio, timezone).toISOString(),
            horaInicio: moment.tz(initialFechaInicio, timezone).toISOString(),
            horaFin: moment.tz(initialFechaFin, timezone).toISOString(),
            todaJornada: false,
            repetir: false,
            diasSemana: [],
            tipo: 'horario_extra',
            _id: `new-${contadorNewItems}`
        };

        setHorariosExtraTemp([
            newHorarioExtra,
            ...horariosExtraTemp
        ]);

        setContadorNewItems( contadorNewItems + 1 );
    }

    const editHorarioExtra = ( horarioExtra ) => {
        setHorariosExtraTemp(
            horariosExtraTemp.map( he => {
                if( he._id === horarioExtra._id ){
                    return horarioExtra;
                }
                return he;
            })
        )
    }
    

    return (
        <div className='horario-extra'>
            <div
                style={{ 
                    backgroundColor: colores.color6,
                    color: colores.colorPrincipal
                }}
                className={`horario-extra-add`}
            >
                <p>Añadir</p>
                <span
                    onClick={ () => addHorarioExtra() }
                ><AddSucursalIcon color={ colores.colorPrincipal } /></span>
            </div>
            {
                horariosExtraTemp.map( (horarioExtra) => (
                    <HorarioExtraItem
                        key={ horarioExtra._id }
                        editMode={ editMode }
                        horarioExtra={ horarioExtra }
                        editHorarioExtra={ editHorarioExtra }
                        deleteHorarioExtra={ deleteHorarioExtra }
                        horariosExtraTemp={ horariosExtraTemp }
                        objProfesional={ objProfesional }
                        descansosTemp={ descansosTemp }
                        empresa={ objProfesional.empresa }
                    />
                ))
            }
        </div>
    )
}

